import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const ServicesPage = () => {
  const services = [
    {
      title: "Lead Generation",
      description:
        "Combine telecalling with other lead generation strategies, such as email marketing and social media outreach, to broaden reach and maximize conversions.",
      icon: "📈",
      image:
        "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      features: [
        "Multi-channel outreach strategy",
        "Lead qualification scoring",
        "CRM integration",
        "Real-time performance tracking",
        "A/B testing for optimization",
      ],
      animation: {
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0 },
      },
    },
    {
      title: "Data Build",
      description:
        "At Augere Strategies , we specialize in crafting bespoke data Solutionss that empower businesses to make informed decisions and target their ideal customers with precision.",
      icon: "🗃️",
      image:
        "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      features: [
        "Custom database development",
        "Data enrichment services",
        "Technographic firmographics",
        "GDPR compliant data",
        "Regular data refresh cycles",
      ],
      animation: {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
      },
    },
    {
      title: "Customer Support",
      description:
        "At Augere Strategies , we provide comprehensive customer support services tailored to businesses of all sizes. Whether you're a startup or enterprise, we've got you covered.",
      icon: "👨‍💻",
      image:
        "https://images.unsplash.com/photo-1521791055366-0d553872125f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
      features: [
        "24/7 multilingual support",
        "Omnichannel Solutionss",
        "Technical support specialists",
        "Customer satisfaction tracking",
        "Scalable support teams",
      ],
      animation: {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { opacity: 1, scale: 1 },
      },
    },
    {
      title: "Webinar Services",
      description:
        "At Augere Strategies , we specialize in maximizing webinar registrations through a powerful combination of email marketing and telecalling to ensure your events are well-attended.",
      icon: "🎤",
      image:
        "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      features: [
        "Targeted audience outreach",
        "Pre-event promotion campaigns",
        "Attendance tracking",
        "Post-webinar follow-up",
        "Performance analytics",
      ],
      animation: {
        hidden: { opacity: 0, rotateY: 90 },
        visible: { opacity: 1, rotateY: 0 },
      },
    },
    {
      title: "Telecalling Services",
      description:
        "Develop targeted telecalling campaigns aimed at specific demographics or industries to maximize outreach effectiveness. Utilize data analytics to refine calling strategies.",
      icon: "📞",
      image:
        "https://images.unsplash.com/photo-1543269664-76bc3997d9ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      features: [
        "Industry-specific scripting",
        "Multi-language capabilities",
        "Call recording & analytics",
        "Appointment setting",
        "Lead qualification",
      ],
      animation: {
        hidden: { opacity: 0, x: 50 },
        visible: { opacity: 1, x: 0 },
      },
    },
  ];

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white py-28 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.1 }}
          transition={{ duration: 1 }}
          className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center"
        />
        <div className="relative max-w-7xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, type: "spring" }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 font-serif"
          >
            Our Services
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="text-xl md:text-2xl max-w-3xl mx-auto"
          >
            Comprehensive demand generation Solutionss designed to accelerate
            your growth
          </motion.p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              variants={service.animation}
              whileHover={{
                y: -10,
                boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
              }}
              className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300"
            >
              <div className="h-48 overflow-hidden relative">
                <motion.img
                  src={service.image}
                  alt={service.title}
                  initial={{ scale: 1 }}
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 0.5 }}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-5xl">
                  {service.icon}
                </div>
              </div>
              <div className="p-6">
                <motion.h3
                  whileHover={{ color: "#2563eb" }}
                  className="text-2xl font-bold text-gray-900 mb-3 font-serif"
                >
                  {service.title}
                </motion.h3>
                <p className="text-gray-600 mb-4">{service.description}</p>

                <ul className="mb-6 space-y-2">
                  {service.features.map((feature, i) => (
                    <motion.li
                      key={i}
                      initial={{ opacity: 0, x: -10 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3, delay: 0.2 + i * 0.05 }}
                      viewport={{ once: true }}
                      className="flex items-start"
                    >
                      <svg
                        className="h-5 w-5 text-blue-500 mr-2 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-gray-700">{feature}</span>
                    </motion.li>
                  ))}
                </ul>

                <motion.button
                  whileHover={{ scale: 1.05, backgroundColor: "#1d4ed8" }}
                  whileTap={{ scale: 0.95 }}
                  className="w-full py-3 px-4 bg-blue-600 text-white font-medium rounded-lg transition-all duration-300"
                >
                  Know More
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif">
              What Our Clients Say
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Success stories from our valued partners
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <Swiper
              slidesPerView={1}
              spaceBetween={30}
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                },
              }}
              modules={[Autoplay, Pagination]}
              className="pb-12"
            >
              {[
                {
                  quote:
                    "Augere's lead generation service increased our qualified leads by 140% in just 3 months. Their multi-channel approach is unmatched.",
                  author: "Sarah Johnson",
                  company: "TechNova Solutionss",
                },
                {
                  quote:
                    "The data build service provided us with the most accurate prospect database we've ever worked with. Conversion rates improved immediately.",
                  author: "Michael Chen",
                  company: "CloudForge Inc.",
                },
                {
                  quote:
                    "Their webinar registration services consistently deliver 3x the industry average attendance rate for our events.",
                  author: "David Wilson",
                  company: "DigitalFirst Marketing",
                },
              ].map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <motion.div
                    whileHover={{ y: -5 }}
                    className="bg-gray-50 p-8 rounded-xl shadow-sm h-full border border-gray-100"
                  >
                    <div className="text-blue-600 text-4xl mb-4">"</div>
                    <p className="text-lg text-gray-600 italic mb-6">
                      {testimonial.quote}
                    </p>
                    <div className="flex items-center">
                      <div className="bg-gradient-to-r from-blue-500 to-blue-700 w-12 h-12 rounded-full mr-4 flex items-center justify-center text-white font-bold">
                        {testimonial.author.charAt(0)}
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900">
                          {testimonial.author}
                        </h4>
                        <p className="text-gray-500">{testimonial.company}</p>
                      </div>
                    </div>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold mb-6 font-serif"
          >
            Ready to Transform Your Demand Generation?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
            className="text-xl mb-8 max-w-3xl mx-auto"
          >
            Schedule a consultation with our experts to discuss how we can help
            you achieve your growth objectives.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row justify-center gap-4"
          >
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="tel:+441416282052"
              className="px-8 py-4 bg-white hover:bg-gray-100 text-blue-600 font-medium rounded-lg transition-all duration-300 flex items-center justify-center gap-2 text-lg"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              +44 1416 282 052
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#"
              className="px-8 py-4 border-2 border-white text-white font-medium rounded-lg transition-all duration-300 hover:bg-white hover:text-blue-600 text-lg"
            >
              Get Free Consultation
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
